module.exports = __webpack_public_path__ + "static/media/thumbnail.40e5820b.jpg";